<template>
    <tci-title class="survey_title" title="2020苏州大宇宙客户大会" subtitle="问卷调查表"  :color="color">
        <v-row v-if="subtitle == '客户调查反馈表'">
            <v-spacer></v-spacer>
            <v-col class="pa-0">
                <!-- 非手机端 -->
                <v-img
                        position="left top"
                        width="680"
                        class="d-none d-sm-flex"
                >
                    <v-row class="mx-2">
                            <v-col class="col-2 survey_wide">
                                <span class="colorred">*</span> 嘉宾姓名:
                            </v-col>
                            <v-col class="col-3 py-1">
                                <v-text-field background-color="rgb(255, 255, 255, 0.4)"  v-model="name" require dense ></v-text-field>
                            </v-col>
                        <v-col></v-col>
                        <v-col></v-col>
                        <v-col></v-col>
                    </v-row>
                    <v-row class="mx-2">
                        <v-divider class="my-2"></v-divider>
                    </v-row>
                    <!--第一块-->
                    <v-row class="mx-0">
                         <v-col>
                             <v-list color="transparent" class="survey_list">
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide"><span class="colorred">*</span> 1，智能制造</v-list-item-title>
                                 </v-list-item>
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide mx-7">  “大宇宙解决方案 助力客户数字化升级”</v-list-item-title>
                                 </v-list-item>
                             </v-list>
                             <v-row class="mx-6">
                                 <el-radio-group v-model="options1_1" @change="updateOptions1_1">
                                     <v-col class="mx-6">
                                         <el-radio  label="4">非常感兴趣</el-radio>
                                         <el-radio  label="3">比较感兴趣</el-radio>
                                         <el-radio  label="2">一般</el-radio>
                                         <el-radio  label="1">不感兴趣</el-radio>
                                     </v-col>
                                 </el-radio-group>
                             </v-row>

                             <v-list color="transparent" class="survey_list">
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide"><span class="colorred">*</span> 2，Low Code</v-list-item-title>
                                 </v-list-item>
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide mx-7">  “OutSystems的介绍及案例分享”</v-list-item-title>
                                 </v-list-item>
                             </v-list>
                             <v-row class="mx-6">
                                 <el-radio-group v-model="options1_2" @change="updateOptions1_2">
                                     <v-col class="mx-6">
                                         <el-radio  label="4">非常感兴趣</el-radio>
                                         <el-radio  label="3">比较感兴趣</el-radio>
                                         <el-radio  label="2">一般</el-radio>
                                         <el-radio  label="1">不感兴趣</el-radio>
                                     </v-col>
                                 </el-radio-group>
                             </v-row>

                             <v-list color="transparent" class="survey_list">
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide"><span class="colorred">*</span> 3，ERP</v-list-item-title>
                                 </v-list-item>
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide mx-7">  “Microsoft Dynamics365 for BC 介绍”</v-list-item-title>
                                 </v-list-item>
                             </v-list>
                             <v-row class="mx-6">
                                 <el-radio-group v-model="options1_3" @change="updateOptions1_3">
                                     <v-col class="mx-6">
                                         <el-radio  label="4">非常感兴趣</el-radio>
                                         <el-radio  label="3">比较感兴趣</el-radio>
                                         <el-radio  label="2">一般</el-radio>
                                         <el-radio  label="1">不感兴趣</el-radio>
                                     </v-col>
                                 </el-radio-group>
                             </v-row>

                             <v-list color="transparent" class="survey_list">
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide"><span class="colorred">*</span> 4，贵宾客户演讲</v-list-item-title>
                                 </v-list-item>
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide mx-7">  “数字化供应链与中国制造共赢”</v-list-item-title>
                                 </v-list-item>
                             </v-list>
                             <v-row class="mx-6">
                                 <el-radio-group v-model="options2_1" @change="updateOptions2_1">
                                     <v-col class="mx-6">
                                         <el-radio  label="4">非常感兴趣</el-radio>
                                         <el-radio  label="3">比较感兴趣</el-radio>
                                         <el-radio  label="2">一般</el-radio>
                                         <el-radio  label="1">不感兴趣</el-radio>
                                     </v-col>
                                 </el-radio-group>
                             </v-row>

                             <v-list color="transparent" class="survey_list">
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide"><span class="colorred">*</span> 5，RPA</v-list-item-title>
                                 </v-list-item>
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide mx-7">  “Dance with UiPath robots”及经典案例分享</v-list-item-title>
                                 </v-list-item>
                             </v-list>
                             <v-row class="mx-6">
                                 <el-radio-group v-model="options2_2" @change="updateOptions2_2">
                                     <v-col class="mx-6">
                                         <el-radio  label="4">非常感兴趣</el-radio>
                                         <el-radio  label="3">比较感兴趣</el-radio>
                                         <el-radio  label="2">一般</el-radio>
                                         <el-radio  label="1">不感兴趣</el-radio>
                                     </v-col>
                                 </el-radio-group>
                             </v-row>

                             <v-list color="transparent" class="survey_list">
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide"><span class="colorred">*</span> 6，大宇宙演讲</v-list-item-title>
                                 </v-list-item>
                                 <v-list-item>
                                     <v-list-item-title class="survey_wide mx-7">  “以人为本---成功的数字化变革”</v-list-item-title>
                                 </v-list-item>
                             </v-list>
                             <v-row class="mx-6">
                                 <el-radio-group v-model="options2_3" @change="updateOptions2_3">
                                     <v-col class="mx-6">
                                         <el-radio  label="4">非常感兴趣</el-radio>
                                         <el-radio  label="3">比较感兴趣</el-radio>
                                         <el-radio  label="2">一般</el-radio>
                                         <el-radio  label="1">不感兴趣</el-radio>
                                     </v-col>
                                 </el-radio-group>
                             </v-row>


                         </v-col>
                    </v-row>
                    <!--建议-->
                    <v-row class="mx-2 mt-0">
                        <v-col class="py-0 survey_textarea">
                            <v-list color="transparent" class="">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide">7，其他意见或想进一步了解的内容</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-textarea class="mx-12 mt-n4" label="" dense
                                        background-color="rgb(255, 255, 255, 0.4)" v-model="suggest"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="mx-12 my-2">
                        <v-btn color="rgb(33 74 101 / 88%)" class="py-2 survey_submin white--text" @click="contact" block>提交问卷</v-btn>
                    </v-row>
                </v-img>
                <!-- 手机端 -->
                <v-img
                        position="left top"
                        class="d-flex d-sm-none"
                        width="980"
                >
                    <v-row class="mt-0">
                        <v-col class="mx-8 px-0 col-3 survey_wide" >
                            <span class="colorred">*</span> 嘉宾姓名:
                        </v-col>
                        <v-col class="py-0 col-5 px-0 mx-n8">
                            <v-text-field class="px-0"  background-color="rgb(255, 255, 255, 0.1)"  v-model="name" require dense ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-0">
                        <v-divider class="my-2"></v-divider>
                    </v-row>
                    <v-row class="mt-0 survey_row">
                        <v-col class="py-0" cols="12">
                            <v-list color="transparent" class="my-0 survey_list">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide"><span class="colorred">*</span> 1，智能制造</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="mx-8 survey_wide">  “大宇宙解决方案 助力客户数字化升级”</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-row class="mx-10">
                                <el-radio-group v-model="options1_1" @change="updateOptions1_1">
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="4">非常感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="3">比较感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="2">一般</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="1">不感兴趣</el-radio>
                                    </v-col>
                                </el-radio-group>
                            </v-row>

                            <v-list color="transparent" class="my-0 survey_list">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide"><span class="colorred">*</span> 2，Low Code</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="mx-8 survey_wide">  “OutSystems的介绍及案例分享”</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-row class="mx-10">
                                <el-radio-group v-model="options1_2" @change="updateOptions1_2">
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="4">非常感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="3">比较感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="2">一般</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="1">不感兴趣</el-radio>
                                    </v-col>
                                </el-radio-group>
                            </v-row>

                            <v-list color="transparent" class="my-0 survey_list">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide"><span class="colorred">*</span> 3，ERP</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="mx-8 survey_wide">  “Microsoft Dynamics365 for BC 介绍”</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-row class="mx-10">
                                <el-radio-group v-model="options1_3" @change="updateOptions1_3">
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="4">非常感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="3">比较感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="2">一般</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="1">不感兴趣</el-radio>
                                    </v-col>
                                </el-radio-group>
                            </v-row>

                            <v-list color="transparent" class="my-0 survey_list">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide"><span class="colorred">*</span> 4，贵宾客户演讲</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="mx-8 survey_wide">  “数字化供应链与中国制造共赢”</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-row class="mx-10">
                                <el-radio-group v-model="options2_1" @change="updateOptions2_1">
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="4">非常感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="3">比较感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="2">一般</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="1">不感兴趣</el-radio>
                                    </v-col>
                                </el-radio-group>
                            </v-row>

                            <v-list color="transparent" class="my-0 survey_list">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide"><span class="colorred">*</span> 5，RPA</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="mx-8 survey_wide">  “Dance with UiPath robots”及经典案例分享</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-row class="mx-10">
                                <el-radio-group v-model="options2_2" @change="updateOptions2_2">
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="4">非常感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="3">比较感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="2">一般</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="1">不感兴趣</el-radio>
                                    </v-col>
                                </el-radio-group>
                            </v-row>

                            <v-list color="transparent" class="my-0 survey_list">
                                <v-list-item>
                                    <v-list-item-title class="survey_wide"><span class="colorred">*</span> 6，大宇宙演讲</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title class="survey_wide mx-8">  “以人为本---成功的数字化变革”</v-list-item-title>
                                </v-list-item>
                            </v-list>
                            <v-row class="mx-10">
                                <el-radio-group v-model="options2_3" @change="updateOptions2_3">
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="4">非常感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="3">比较感兴趣</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="2">一般</el-radio>
                                    </v-col>
                                    <v-col class="py-2" cols="12">
                                        <el-radio  label="1">不感兴趣</el-radio>
                                    </v-col>
                                </el-radio-group>
                            </v-row>

                        </v-col>
                    </v-row>

                    <v-row class="mt-0">
                        <v-list color="transparent" class="my-0">
                            <v-list-item>
                                <v-list-item-title class="mx-4 survey_wide"> 7，其他意见或想进一步了解的内容</v-list-item-title>
                            </v-list-item>
                        </v-list>
                        <v-col class="py-0 survey_textarea " cols="12">
                            <v-textarea  label=""  class="px-4 mx-8 mt-n4"
                                        background-color="rgb(255, 255, 255, 0.4)" v-model="suggest"
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-row class="mx-4 my-12">
                        <v-btn color="rgb(33 74 101 / 88%)" class="py-2 survey_submin white--text" @click="contact" block>提交问卷</v-btn>
                    </v-row>
                </v-img>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
    </tci-title>
</template>

<script>
    import TciTitle from "@/components/TciTitle.vue";
    import axios from "axios";
    //双垒打
    var inputClick = true;
    export default {
        name: 'Survey',
        components: {
            "tci-title": TciTitle,
        },
        data: () => ({
            name:"",
            suggest:"",
            subtitle:"客户调查反馈表",
            basic_info:[],
            options1_1:"",
            options1_2:"",
            options1_3:"",
            options2_1:"",
            options2_2:"",
            options2_3:""
        }),
        props: {
            "color": String
        },
        mounted: function(){
            this.getShow();
        },
        methods: {
            getShow: function(){
                var _this = this;
               /* var date = new Date();
                var surveyDate = new Date("2020-11-01");*/
                _this.subtitle = "客户调查反馈表";
                /*if (date.getTime() - surveyDate.getTime() < 0) {
                    _this.subtitle = "客户调查反馈表";
                    return false;
                } else {
                    _this.subtitle = "大会报名已截止！期待您的下次参与！";
                    return true;
                }*/
            },

            updateOptions1_1:function(val){
                this.basic_info['options1_1'] = val
            },
            updateOptions1_2:function(val){
                this.basic_info['options1_2'] = val
            },
            updateOptions1_3:function(val){
                this.basic_info['options1_3'] = val
            },
            updateOptions2_1:function(val){
                this.basic_info['options2_1'] = val
            },
            updateOptions2_2:function(val){
                this.basic_info['options2_2'] = val
            },
            updateOptions2_3:function(val){
                this.basic_info['options2_3'] = val
            },

            contact: function(){
                //重新定义
                var _this = this;
                //获取值
                var name = _this.name;
                var suggest = _this.suggest;
                var options1_1 = _this.basic_info['options1_1'];
                var options1_2 = _this.basic_info['options1_2'];
                var options1_3 = _this.basic_info['options1_3'];
                var options2_1 = _this.basic_info['options2_1'];
                var options2_2 = _this.basic_info['options2_2'];
                var options2_3 = _this.basic_info['options2_3'];

                //验证
                if(!name){
                    _this.$message({
                        message: '请输入嘉宾姓名',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!options1_1){
                    _this.$message({
                        message: '请选择智能制造',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!options1_2){
                    _this.$message({
                        message: '请选择Low Code',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!options1_3){
                    _this.$message({
                        message: '请选择ERP',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!options2_1){
                    _this.$message({
                        message: '请选择贵宾客户演讲',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!options2_2){
                    _this.$message({
                        message: '请选择RPA',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }else if(!options2_3){
                    _this.$message({
                        message: '请选择大宇宙演讲',
                        type: 'error',
                        offset:300,
                        duration:1000
                    });
                    return false;
                }

                //api参数
                var params = new URLSearchParams();
                params.append('name',name);
                params.append('suggest', suggest);
                params.append('options1_1', options1_1);
                params.append('options1_2', options1_2);
                params.append('options1_3', options1_3);
                params.append('options2_1', options2_1);
                params.append('options2_2', options2_2);
                params.append('options2_3', options2_3);
                if(inputClick){
                    inputClick = false;
                    //调用api
                    //axios.post('http://172.16.1.153:9060/signUp/seminar/surveyPostApi.php', params)
                    axios.post('http://58.240.228.70:8068/seminar/surveyPostApi.php', params)
                        .then(function (result) {
                            inputClick = true;
                            console.log(result);
                            //返回结果
                            if(result.data.res == 1){
                               _this.$message({
                                    showClose: true,
                                    message: result.data.mes,
                                    type: 'success',
                                    offset:300
                                });
                                //成功清空输入框
                                _this.name = "";
                                _this.suggest = "";
                                _this.options1_1 = "";
                                _this.options1_2 = "";
                                _this.options1_3 = "";
                                _this.options2_1 = "";
                                _this.options2_2 = "";
                                _this.options2_3 = "";
                            }else{
                                _this.$message({
                                    showClose: true,
                                    message: result.data.mes,
                                    type: 'error',
                                    offset:300
                                });
                            }
                        })
                        .catch(function (error) { // 请求失败处理
                            inputClick = true;
                            console.log(error);
                        })
                }

            }

        }

    }
</script>
<style>
    .survey_submin span{
        font-weight: 500;
        font-size: 1.2rem;
    }
    .colorred{
        color: red;
    }
     .survey_list .v-list-item{
        min-height: 24px !important;
    }
    .survey_title  .v-card__title{
        font-size: 2rem !important;
        color: #39a4db !important;
    }

    .survey_wide{
        font-weight:bold
    }

    .survey_title  .v-card__subtitle{
        font-size: 2rem !important;
        color: #39a4db !important;
    }
    .survey_input input,.survey_textarea textarea{
        border-style: solid !important;
    }

    .survey_submin{
        background-color: rgba(33, 74, 101, 0.88) !important;
        border-color: rgba(33, 74, 101, 0.88) !important;
    }

    .survey_row .el-radio__inner{
        width: 18px !important;
        height: 18px !important;
    }
    @media (max-width: 750px){
        .survey_title  .v-card__title{
            font-size: 1.8rem !important;
        }
        .survey_title  .v-card__subtitle{
            font-size: 1.8rem !important;
        }
        .survey_submin{
            height: 40px !important;
        }
    }
</style>